var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseLoginMobileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 800,
    viewBox: "0 0 375 800",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2264_4591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.363263 44H375.004V193.522C375.004 193.522 337.926 390.311 225.453 393.406C112.98 396.501 57.7712 499.606 0.367169 414.137C-0.452831 405.211 0.363263 337.239 0.363263 44Z",
    fill: "#F0EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M375 360.983V408.064H356.21C356.21 408.064 332.11 408.112 331.091 389.27C330.072 370.428 317.744 368.197 328.486 360.983C329.607 360.88 338.149 360.983 375 360.983Z",
    fill: "#F0EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.363263 0H375.004V387.522C375.004 387.522 337.926 354.311 225.453 357.406C112.98 360.501 57.7712 463.606 0.367169 378.137C-0.452831 369.211 0.363263 293.239 0.363263 0Z",
    fill: "#616BF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2264_4591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseLoginMobileBg);
export default __webpack_public_path__ + "static/media/purchaseLoginMobileBg.799773919f53a38269d464f595059718.svg";
export { ForwardRef as ReactComponent };